import { render, staticRenderFns } from "./ReviewOfficerStat.vue?vue&type=template&id=3e1fffc9&scoped=true"
import script from "./ReviewOfficerStat.vue?vue&type=script&lang=js"
export * from "./ReviewOfficerStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1fffc9",
  null
  
)

export default component.exports